import React from 'react'
import AppContext from 'AppContext'
import { adminEmail } from 'components/Helpers'

const Admins = ({ match }) => {
  let env = 'staging'
  if (/.*admin.evofitness.*/.test(window.location.origin)) {
    env = 'production'
  }
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id, name: operatorName }, currentAdmin } = React.useContext(AppContext)

  if (!id) {
    return <div className='index'><p>waiting for operator...</p></div>
  }

  return (
    <div className='index'>
      {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
      <h1></h1>
      <cl-admins
        operatorId={id}
        token={token}
        apiHost={`https://administrators.${env}.credlock.net`}
        mountPath={`/operators/${id}/administrators`}
        currentUser={adminEmail(currentAdmin)}
        operatorName={operatorName || ''}
        accessControlApiUrl={`https://access-control.${env}.credlock.net/api`}
      />
    </div>
  )
}

export default Admins
